import React from 'react';
import { useSelector } from "react-redux";
import ico_card from './../../../../assets/icons/ico_card.svg';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ico_moneda from './../../../../assets/icons/ico_moneda.svg';
import { validateDateFormat, formatAmount2 } from '../../../../lib/utils/utilitarios';
import HeaderComponent from '../../../../components/header/header_component';
import ButtonComponent from '../../../../components/button/button_component';
import NotificationComponent from '../../../../components/notification/notification_component';
import cn from '../../../../lib/bem';
import { LAYOUT_PAG } from '../../constants/content_pag';

import './infoDevMensaje.scss';

const InfoDevMensaje = ({mostrarPolizaMensaje}) => {
  
  const classes = cn("infoDevMensaje");
  const endosoPoliza    = JSON.parse(sessionStorage.getItem("infoPoliza"));
  const datosEndoso     = useSelector((state) => state.rootReducers.endosoPoliza);
  const productCatalog  = useSelector((state) => state.rootReducers.productCatalog);

  const regresarMepPolizaNoMadura = () => {
    if(datosEndoso.datosPoliza?.aplicaEndoso){
      mostrarPolizaMensaje(LAYOUT_PAG.PAG_LAY );
    } else {
      window.parent.postMessage('close-iframe', '*');
    }
  }

  const mostrarMensaje = () => {
    const variableName = `REACT_APP_MSG_FINALIZACION_ERROR_${datosEndoso.datosPoliza?.codigoMensaje}`;
    const mensajeError = process.env[variableName];

    return datosEndoso.datosPoliza?.aplicaEndoso ?
      <p className={classes('descrConfEditMensaje')}>Tu p&oacute;liza est&aacute; a punto de finalizar el plazo de contrataci&oacute;n, por eso, te pediremos los datos de tu cuenta bancaria para poder iniciar con la devoluci&oacute;n de la prima seg&uacute;n el plan que contrataste.</p>
    : 
      <p className={classes('descrConfEditMensaje')} dangerouslySetInnerHTML={{ __html: mensajeError}}></p>
  }

  const mostrarNotificacion = () => {
    return datosEndoso.error !== "" || productCatalog.error !== ""? 
      <div>
        <br/>
        <NotificationComponent faIcon={faTimes} textNotification={datosEndoso.error !== "" ? datosEndoso.error : productCatalog.error} tipo="error"/>
        <br/>
      </div>
    :
      <div> 
        <p className={classes('titleConfEditMensaje')}><b>Finalizaci&oacute;n de plazo de p&oacute;liza</b></p>
        {
          mostrarMensaje()
        }
      </div>
  }
  
  const validarError = datosEndoso.datosPoliza?.aplicaEndoso ? 'Continuar' : 'Cerrar';

  return (
    <div className={classes()}>
      <HeaderComponent flagHeaderMobile={false} index={false} title={"Finalización de plazo de póliza"}/>
      {
        datosEndoso.solicitudEndoso === null ?
          <div className={classes('infoDevMensajeDiv')}>
            <img src={ico_card} alt='cobrar' />
              {
               mostrarNotificacion()
              }
            {/* <p className={classes('descrConfEditMensaje')}>Si tienes alguna consulta revisa tu p&oacute;liza o comun&iacute;cate con <a className={classes('linkTel')} href="tel:015135000">(01) 513 5000</a>.</p> */}
            <div className={classes('btnContinuarMensaje')}>
                <ButtonComponent label={'btnContinuar'} nombre={ validarError } tipo={'button-red'} action={() => regresarMepPolizaNoMadura()} disabled={false}/>
            </div>
          </div>
        : 
          <div className={classes('infoDevMensajeDiv')}>
            <div className={classes('infoDevTitulo')} >
              <img src={ico_moneda} alt='cobrar' />
              <b>Finalizaci&oacute;n de plazo de p&oacute;liza</b> 
            </div>
            <hr className={classes('showDiv')}/>
            <div className={classes('infoDevDesc')} >
              <p>N° de P&oacute;liza/Plan:</p>
              <p>{endosoPoliza?.numpol}</p>
            </div>
            <hr />
            <div className={classes('infoDevDesc2')} >
              <p>Monto de finalizaci&oacute;n de tu p&oacute;liza</p>
              <p>{datosEndoso.datosPoliza?.simboloMoneda} <span>{formatAmount2(datosEndoso.solicitudEndoso?.montoSolicitud + '')}</span></p>
            </div>
            <hr />
            <div className={classes('infoDevDesc')} >
              <p>Fecha de ingreso de registro:</p>
              <p>{validateDateFormat(datosEndoso.solicitudEndoso?.fechaSolicitud, 'dd/MM/yyyy')}</p>
            </div>
            <br/><br/>
            <NotificationComponent faIcon={null} textNotification={`Tus datos han sido registrados para el proceso de finalización de tu póliza. Si deseas cambiar los datos de tu cuenta bancaria puedes hacerlo llamando al (01) 513 5000 hasta 7 días hábiles del vencimiento de tu póliza. El número de atención es ${datosEndoso.solicitudEndoso?.numeroSolicitudServicio}`} tipo="information"/>
          </div>
      }
    </div>
  );
}



export default InfoDevMensaje;
